import React from 'react';
import { ShoppingBagIcon, ClockIcon, DollarSignIcon, ReceiptIcon, ActivityIcon } from 'lucide-react';
import { DashboardStatsData } from './types';
import { CONFIG } from '../data/config';
interface DashboardStatsProps {
  stats: DashboardStatsData;
}
export function DashboardStats({
  stats
}: DashboardStatsProps) {
  const loadLevel = stats.ordersLastHour <= 5 ? 'low' : stats.ordersLastHour <= 10 ? 'medium' : 'high';
  const loadConfig = {
    low: {
      label: 'Carga baja',
      color: 'text-emerald-400',
      bg: 'bg-emerald-400/10 border-emerald-400/20',
      icon: 'bg-emerald-400/20',
      barColor: 'bg-emerald-400',
      barWidth: 'w-1/3'
    },
    medium: {
      label: 'Carga media',
      color: 'text-yellow-400',
      bg: 'bg-yellow-400/10 border-yellow-400/20',
      icon: 'bg-yellow-400/20',
      barColor: 'bg-yellow-400',
      barWidth: 'w-2/3'
    },
    high: {
      label: 'Alta demanda',
      color: 'text-red-400',
      bg: 'bg-red-400/10 border-red-400/20',
      icon: 'bg-red-400/20',
      barColor: 'bg-red-400',
      barWidth: 'w-full'
    }
  };
  const load = loadConfig[loadLevel];
  return <div className="grid grid-cols-5 gap-4" data-id="element-134">
      {/* Orders Today */}
      <div className="bg-surface rounded-2xl p-5 border border-gray-800" data-id="element-135">
        <div className="flex items-center justify-between mb-3" data-id="element-136">
          <div className="p-2.5 bg-blue-400/10 rounded-xl" data-id="element-137">
            <ShoppingBagIcon className="w-5 h-5 text-blue-400" data-id="element-138" />
          </div>
        </div>
        <p className="text-3xl font-bold text-white font-heading tracking-wide" data-id="element-139">
          {stats.ordersToday}
        </p>
        <p className="text-sm text-gray-500 mt-1" data-id="element-140">Pedidos hoy</p>
      </div>

      {/* Orders Last Hour */}
      <div className="bg-surface rounded-2xl p-5 border border-gray-800" data-id="element-141">
        <div className="flex items-center justify-between mb-3" data-id="element-142">
          <div className="p-2.5 bg-purple-400/10 rounded-xl" data-id="element-143">
            <ClockIcon className="w-5 h-5 text-purple-400" data-id="element-144" />
          </div>
        </div>
        <p className="text-3xl font-bold text-white font-heading tracking-wide" data-id="element-145">
          {stats.ordersLastHour}
        </p>
        <p className="text-sm text-gray-500 mt-1" data-id="element-146">Última hora</p>
      </div>

      {/* Sales Today */}
      <div className="bg-surface rounded-2xl p-5 border border-gray-800" data-id="element-147">
        <div className="flex items-center justify-between mb-3" data-id="element-148">
          <div className="p-2.5 bg-emerald-400/10 rounded-xl" data-id="element-149">
            <DollarSignIcon className="w-5 h-5 text-emerald-400" data-id="element-150" />
          </div>
        </div>
        <p className="text-3xl font-bold text-white font-heading tracking-wide" data-id="element-151">
          {CONFIG.CURRENCY_SYMBOL}
          {stats.salesToday.toLocaleString()}
        </p>
        <p className="text-sm text-gray-500 mt-1" data-id="element-152">Ventas hoy</p>
      </div>

      {/* Average Ticket */}
      <div className="bg-surface rounded-2xl p-5 border border-gray-800" data-id="element-153">
        <div className="flex items-center justify-between mb-3" data-id="element-154">
          <div className="p-2.5 bg-dorado/10 rounded-xl" data-id="element-155">
            <ReceiptIcon className="w-5 h-5 text-dorado" data-id="element-156" />
          </div>
        </div>
        <p className="text-3xl font-bold text-white font-heading tracking-wide" data-id="element-157">
          {CONFIG.CURRENCY_SYMBOL}
          {stats.averageTicket.toLocaleString()}
        </p>
        <p className="text-sm text-gray-500 mt-1" data-id="element-158">Ticket promedio</p>
      </div>

      {/* Operational Load */}
      <div className={`rounded-2xl p-5 border ${load.bg}`} data-id="element-159">
        <div className="flex items-center justify-between mb-3" data-id="element-160">
          <div className={`p-2.5 rounded-xl ${load.icon}`} data-id="element-161">
            <ActivityIcon className={`w-5 h-5 ${load.color}`} data-id="element-162" />
          </div>
        </div>
        <p className={`text-lg font-bold ${load.color}`} data-id="element-163">{load.label}</p>
        <div className="mt-2 h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-164">
          <div className={`h-full rounded-full transition-all duration-500 ${load.barColor} ${load.barWidth}`} data-id="element-165" />
        </div>
        <p className="text-xs text-gray-500 mt-2" data-id="element-166">
          {stats.ordersLastHour} pedidos/hora
        </p>
      </div>
    </div>;
}